import { Node_Type } from "./../../../../../ricos-schema/legacy/wix/rich_content/v1/index.js";
import { fromExternalNode } from "./from-external-node.js";
const getPluginRenderers = (context, typeMappers, nodeViewRenderers, SpoilerViewerWrapper) => {
  const convertedTypeMappers = Object.entries(typeMappers).reduce(
    (renderers, [type, pluginComponent]) => {
      if (type === Node_Type.EXTERNAL) {
        return {
          ...renderers,
          ...fromExternalNode({ pluginComponent, type, context, SpoilerViewerWrapper })
        };
      }
      return { ...renderers };
    },
    {}
  );
  return { ...convertedTypeMappers, ...nodeViewRenderers };
};
export {
  getPluginRenderers
};
//# sourceMappingURL=get-plugin-renderers.js.map
